// extracted by mini-css-extract-plugin
module.exports = {"applicationStatus":"applicationStatus_applicationStatus__1EvUT","offline":"applicationStatus_offline__3JXTY"};